//import libraries
import { Component, OnInit } from '@angular/core';

//import constants
import { AppSettings } from '../../../constants/app-settings';
import { AppPermissions } from '../../../constants/app-permission';
import { AppFrontRoutes } from '../../../constants/app-front-routes';

//import services
import { DashboardService } from '../../../services/dashboard.service';
import { SuperAdminService } from '../../../services/superadmin.service';
import {
  ApexChart,
  ApexAxisChartSeries,
  ChartComponent,
  ApexDataLabels,
  ApexPlotOptions,
  ApexYAxis,
  ApexLegend,
  ApexGrid
} from "ng-apexcharts";



type ApexXAxis = {
  type?: "category" | "datetime" | "numeric";
  categories?: any;
  labels?: {
    style?: {
      colors?: string | string[];
      fontSize?: string;
    };
  };
};

export type ChartOptions = {
  series: ApexAxisChartSeries;
  chart: ApexChart;
  dataLabels: ApexDataLabels;
  plotOptions: ApexPlotOptions;
  yaxis: ApexYAxis;
  xaxis: ApexXAxis;
  grid: ApexGrid;
  colors: string[];
  legend: ApexLegend;
};
@Component({
  selector: '[app-admin_dashboard]',
  templateUrl: './admin_dashboard.component.html',
  styleUrls: ['./admin_dashboard.component.css'],
  host: {'id': 'content'},
  providers: [SuperAdminService]
})
export class AdminDashboardComponent implements OnInit {

  readonly AppSettings = AppSettings;
  readonly AppPermissions = AppPermissions;
  readonly AppFrontRoutes = AppFrontRoutes;

  dashboardData
  language;
  recent_user: any;
  exp_user: any;
  total_users: any;
  total_login: any;
  renew: any;
  installChartOptions:any;
  valueChartOptions:any;
  pieChartOptions:any;
  no_of_install = [ 0,0,0,0,0,0,0,0,0,0 ]
  no_of_value = [ 0,0,0,0,0,0,0,0,0,0 ]
  installSeries = [{
    name: "distibuted",
    data: []
  }]
  constructor(
    private superadminService : SuperAdminService
  ) { }

  ngOnInit() {
    console.log("-- Inside --- component --")
    this.pieChartOptions = ""

    this.valueChartOptions = {
      series: [
        {
          name: "value",
          data: this.no_of_value
        }
      ],
      chart: {
        height: 350,
        type: "bar"
      },
      plotOptions: {
        bar: {
          columnWidth: "40%",
          distributed: true
        }
      },
      dataLabels: {
        enabled: false
      },
      legend: {
        show: false
      },
      grid: {
        show: false
      },
      xaxis: {
        categories: [
          "Timetable",
          "Servicing",
          ["Human", "Resource"],
          ["Measurement" , "Tools"],
          ["Problem", "Solving"],
          ["Document", "Management"],
          "Client",
          "Consultancy",
          "Academy",
          "Project",
        ],
        labels: {
          style: {
            colors: [
              "#f89648",
              "#f89648",
              "#f89648",
              "#f89648",
              "#f89648",
              "#f89648",
              "#f89648",
              "#f89648",
              "#f89648",
              "#f89648"
            ],
            fontSize: "12px"
          }
        }
      }
    };

    this.installChartOptions = {
      series: [
        {
          name: "install",
          data: this.no_of_install
        }
      ],
      chart: {
        height: 350,
        type: "bar"
      },
      plotOptions: {
        bar: {
          columnWidth: "40%",
          distributed: true
        }
      },
      dataLabels: {
        enabled: false
      },
      legend: {
        show: false
      },
      grid: {
        show: false
      },
      xaxis: {
        categories: [
          "Timetable",
          "Servicing",
          ["Human", "Resource"],
          ["Measurement" , "Tools"],
          ["Problem", "Solving"],
          ["Document", "Management"],
          "Client",
          "Consultancy",
          "Academy",
          "Project",
        ],
        labels: {
          style: {
            colors: [
              "#f89648",
              "#f89648",
              "#f89648",
              "#f89648",
              "#f89648",
              "#f89648",
              "#f89648",
              "#f89648",
              "#f89648",
              "#f89648"
            ],
            fontSize: "12px"
          }
        }
      }
    };

    this.superadminService.getList()
      .subscribe(
        (res) => {
          this.recent_user = res.data.recent_user;          
          this.exp_user = res.data.exp_user;          
          this.total_users = res.data.total_users;          
          this.total_login = res.data.total_login;          
          this.renew = res.data.renew;          
          this.no_of_install = res.data.no_of_install
          this.no_of_value = res.data.no_of_value
          
          // ChartComponent.u
          this.installChartOptions.series = [{
            data: this.no_of_install
          }];          

          this.valueChartOptions.series = [{
            data: this.no_of_value
          }];   

          // this.pieChartOptions.series  = [{
          //   data: [].concat(...res.data.pie_chart_values)
          // }];     

          // this.pieChartOptions.labels  = [{
          //   data: [].concat(...res.data.pie_chart_labels)
          // }];        
          
          this.pieChartOptions = {
            series: [].concat(...res.data.pie_chart_values),
            chart: {
              width: 620,
              type: "pie"
            },
            labels: [].concat(...res.data.pie_chart_labels),
            responsive: [
              {
                breakpoint: 480,
                options: {
                  chart: {
                    width: 200
                  },
                  legend: {
                    position: "bottom"
                  }
                }
              }
            ]
          };          

          console.log([].concat(...res.data.pie_chart_values) )
          console.log([].concat(...res.data.pie_chart_labels))
        }
    );
    


  }

}
